var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin-bottom":"48px"}},[_c('div',{staticClass:"main"},[_c('div',[_vm._v("跳转中")])])])
}]

export { render, staticRenderFns }